import React from 'react';
import { Link } from 'react-router-dom';
import { WorkspaceApiClient } from '@/infrastructure/workspace/WorkspaceApiClient';
import { useAppTranslation } from '@/i18n/useAppTranslation';

function fmtDate(ts) {
  if (!ts) return 'N/A';
  try {
    return new Date(Number(ts)).toLocaleString();
  } catch {
    return 'N/A';
  }
}

export default function ClassQuizResultsPage({ session, classId, quizId }) {
  const { t } = useAppTranslation();
  const api = React.useMemo(() => new WorkspaceApiClient(), []);
  const token = session?.accessToken || null;
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    let mounted = true;
    if (!token) return undefined;
    setLoading(true);
    api
      .getClassQuizResults(classId, quizId, token)
      .then((x) => {
        if (!mounted) return;
        setItems(Array.isArray(x?.items) ? x.items : []);
      })
      .catch((e) => setError(e.message || t('errors.loadClassQuizResults')))
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [api, classId, quizId, token, t]);

  return (
    <div className="mx-auto max-w-6xl space-y-6">
      <div className="flex items-center justify-between gap-3">
        <h1 className="font-headline text-3xl font-extrabold">Kết quả bài tập theo học sinh</h1>
        <Link
          to={`/classes/${encodeURIComponent(classId)}`}
          className="inline-flex items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:border-[#004ac6] hover:text-[#004ac6]"
        >
          <span className="material-symbols-outlined !text-base">arrow_back</span>
          Quay lại class
        </Link>
      </div>
      <p className="text-sm text-slate-600">Quiz ID: {quizId}</p>

      {loading ? <p className="text-sm text-slate-600">Đang tải...</p> : null}
      {error ? <p className="text-sm font-semibold text-rose-700">{error}</p> : null}

      <div className="space-y-2">
        {items.map((r, idx) => (
          <article key={`${r.student_id}-${r.result_id || idx}`} className="rounded-xl border border-slate-100 bg-white p-3 shadow-sm">
            <p className="font-semibold text-slate-900">{r.student_name}</p>
            <p className="text-xs text-slate-500">{r.student_id}</p>
            {r.result_id ? (
              <p className="mt-1 text-sm text-slate-700">
                Score: {r.score}% ({r.correct_answers}/{r.total_questions}) • {fmtDate(r.timestamp)}
              </p>
            ) : (
              <p className="mt-1 text-sm font-semibold text-amber-700">Chưa làm bài</p>
            )}
          </article>
        ))}
        {!loading && items.length === 0 ? (
          <p className="rounded-xl border border-slate-100 bg-white p-4 text-sm text-slate-600">Không có dữ liệu.</p>
        ) : null}
      </div>
    </div>
  );
}
